import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import GetAllHostelRooms from "../../../../Controllers/Common/GetAllHostelRooms";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function RoomsListingViewModel() {
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [RoomsArray, setRoomsArray] = useState([]);
  const [AuthUser, setAuthUser] = useState({});

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const RoomsData = await GetAllHostelRooms(SchoolID);
      setRoomsArray(RoomsData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  return {
    RoomsArray,
    AuthUser,
    IsLoading,
  };
}
